import React from 'react';
import { connect } from 'react-redux';

import MainContent from '../components/layout/MainContent';
import Title from '../components/typography/Title';
import TaraFloatingActionButtonContainer from '../containers/TaraFloatingActionButtonContainer';
import TaraSurveyContainer from '../containers/TaraSurveyContainer';
import LatestEventsContainer from '../containers/LatestEventsContainer';
import { getHasAnsweredSurvey } from '../reducers/tara/hasAnsweredSurvey';

import { createFetchingView } from '../helpers/views';

class HomeView extends React.PureComponent {
  get shouldRenderTaraSurvey() {
    const { features, locationQuery, hasAnsweredSurvey } = this.props;

    return !!locationQuery.tara && features.taraSurvey && !hasAnsweredSurvey;
  }

  renderContent() {
    const { curated, tara } = this.props.locationQuery;

    return (
      <MainContent
        id="HomeView"
        className="sk-fade-in-quarter-second relative"
      >
        <Title align="center">Latest Events</Title>
        <LatestEventsContainer
          isTara={!!tara}
          isCurated={!!curated}
        />
      </MainContent>
    );
  }

  render() {
    if (this.props.isReady) {
      return this.renderContent();
    }

    return null;
  }
}

const getState = (state, ownProps) => ({
  isFetching: false,
  hasAnsweredSurvey: getHasAnsweredSurvey(state),
  ...ownProps,
});

export default connect(getState)(createFetchingView(HomeView));



// WEBPACK FOOTER //
// ./src/views/HomeView.js